// Reduce las fotos grandes (por ejemplo, de la cámara del teléfono) antes de subirlas.
// Si algo falla devuelve el archivo original: el servidor también reduce las imágenes.
const SUPPORTED_TYPES = ['image/jpeg', 'image/jpg', 'image/png']
const SMALL_FILE_BYTES = 2 * 1024 * 1024

export async function compressImage(file, { maxSide = 2560, quality = 0.85 } = {}) {
    if (!file || !SUPPORTED_TYPES.includes(file.type)) {
        return file
    }

    let loaded = null
    let canvas = null
    try {
        loaded = await loadImage(file)
        const { naturalWidth: width, naturalHeight: height } = loaded.image
        const longestSide = Math.max(width, height)
        if (!longestSide || (longestSide <= maxSide && file.size <= SMALL_FILE_BYTES)) {
            return file
        }

        const scale = Math.min(1, maxSide / longestSide)
        canvas = document.createElement('canvas')
        canvas.width = Math.round(width * scale)
        canvas.height = Math.round(height * scale)
        const context = canvas.getContext('2d')
        // Fondo blanco porque un PNG con transparencia se convierte a JPEG
        context.fillStyle = '#fff'
        context.fillRect(0, 0, canvas.width, canvas.height)
        // <img> ya aplica la orientación EXIF, así que el canvas queda derecho
        context.drawImage(loaded.image, 0, 0, canvas.width, canvas.height)

        const blob = await canvasToBlob(canvas, 'image/jpeg', quality)
        if (!blob || (longestSide <= maxSide && blob.size >= file.size)) {
            return file
        }
        return new File([blob], toJpegName(file.name), { type: 'image/jpeg', lastModified: Date.now() })
    } catch (error) {
        console.error('compressImage', error)
        return file
    } finally {
        if (loaded) {
            URL.revokeObjectURL(loaded.url)
        }
        if (canvas) {
            // iOS Safari retiene la memoria del canvas hasta el GC si no se reduce
            canvas.width = 0
            canvas.height = 0
        }
    }
}

function loadImage(file) {
    return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file)
        const image = new Image()
        image.onload = () => resolve({ image, url })
        image.onerror = () => {
            URL.revokeObjectURL(url)
            reject(new Error('Image could not be decoded'))
        }
        image.src = url
    })
}

function canvasToBlob(canvas, type, quality) {
    return new Promise((resolve) => canvas.toBlob(resolve, type, quality))
}

function toJpegName(name) {
    return (name || 'foto').replace(/\.[^.]+$/, '') + '.jpg'
}
